/* Stienhardt - keep the Shopify Inbox chat launcher permanently lifted above
   where the sticky "Add to Ring" bar sits (2026-06-27). Re-applies if Inbox
   resets its own position. Revert = remove this file + its <script>. */
(function () {
  'use strict';
  var BOTTOM = 100; /* sticky bar = bottom 14 + ~74 tall + ~12 gap */
  var mo;
  function set(chat){ if(chat.style.bottom !== BOTTOM+'px'){ chat.style.setProperty('bottom', BOTTOM+'px', 'important'); } }
  function attach(chat){
    set(chat);
    try{ mo=new MutationObserver(function(){ set(chat); }); mo.observe(chat,{attributes:true,attributeFilter:['style']}); }catch(e){}
  }
  var n=0, iv=setInterval(function(){ n++; var chat=document.querySelector('#ShopifyChat'); if(chat){ attach(chat); clearInterval(iv); } else if(n>160){ clearInterval(iv); } }, 200);
})();
